export default {
    BACKEND_URL: "https://scantool-v2-backend.synup.com",
    FRONTEND_URL: "https://scantool-v2.synup.com",
}
